/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-04-16 17:55:22
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2021-11-24 18:13:48
 * @Description: 绑定如是一篇内容页面，产生销售线索。
 * config.js 里面需要配置
       apiRushiH5Platform: {
        protocol: "http:",
        domain: "qmyx.ttrushi.com",
      },
      httpRushiH5Platform: null,
      servicesRushiH5jssdk: {
        pageid: 150279,
        psn: "7cb32ae349724ee19f9d41abc48ce23e",
        projectid: 61,
        saleslead: {
          browse: true,
          share: true,
          leavePhone: true
        }
      },
      apiRushiWxPlatform: {
        protocol: "http:",
        domain: "qmyx.ttrushi.com",
      },
      httpRushiWxPlatform: {
        borrowOpenid: 'oj3y9wGThdLqhn0bZWOj7DeO2Tww',
        borrowPassport: 'b4de197ab7b03e9d014116821e90d54f',
      }
 * 
 * borrowOpenid和borrowPassport为固定的本公众号的一对openid和passport用于请求接口，因为活动里面没有passport。
 * 1、一打开页面就提交浏览信息
 * 2、分享回调加上
 * this.$rsh5.actShare();
 * 3、留电的时候调用下
 * this.$rsh5.actEntry(strPhone);
 * 4、设置分享的链接用 this.$rsh5.getRsShareUrl(要分享的链接) 返回的链接
 * 5、如果在非develop分支做，需要合并下develop分支的这几个文件： 
 * api/rushi-wx-platform.js 
 * http/rushi-wx-platform.js 
 * plugins/act-plugin.js 
 * routers/act-wxauth.js 
 * utils/common.js 
 */

import httprsh5 from "@/http/rushi-h5-platform"
import apirsh5 from "@/api/rushi-h5-platform";
import apirswx from '@/api/rushi-wx-platform';
import httprswx from '@/http/rushi-wx-platform';
import util from '@/utils/common';
let _options = {
  pageid: 0,
  psn: "",
  projectid: 0,
  openid: "",
  refereeopenid: "",
  tempid: "",
  channelid: 0,
  saleslead: {
    browse: false,
    share: false,
    leavePhone: false
  },
  rscuid: '',
  isInit: false,
  isSale: false
};
function init(obj) {
  return new Promise((resolve) => {
    if (_options.isInit) {
      resolve();
      return
    }
    _options.isInit = true;
    Object.assign(_options, obj);
    // 如果没有开启任何一个统计
    if (!(_options.saleslead.share || _options.saleslead.leavePhone || _options.saleslead.browse)) {
      resolve();
      return
    }
    // 先获取是否是销售
    httprswx.get("", {
      action: apirswx.action.globalUserGetUserInfo2,
      requestParam: {
        openid: _options.openid
      }
    }).then(res => {
      if (res && res.data && res.data.obj && res.data.obj.saleropenid) {
        _options.isSale = true
      }
      if (_options.saleslead.share == true || _options.saleslead.leavePhone == true) {
        _options.saleslead.browse = true;//分享和留电销售线索推送必须要有浏览
      }
      if (_options.saleslead.browse) {
        _options.tempid = util.getGuid();
        setTimeout(function () {
          actIp();
          setInterval(function () {
            actIp();
          }, 3000);
        }, 1000);
      }
      resolve();
    })
  })
}
function actIp() {
  if (_options.saleslead.browse) {
    let postObj = {
      openid: _options.openid,
      pageid: _options.pageid,
      projectid: _options.projectid,
      psn: _options.psn,
      tempid: _options.tempid
    };
    if (_options.refereeopenid) {
      postObj.refereeopenid = _options.refereeopenid;
    }
    if (_options.rscuid) {
      postObj.rscuid = _options.rscuid;
    }
    httprsh5.post(apirsh5.action.actIp, postObj);
  }
}

function actShare() {
  if (_options.saleslead.share) {
    let postObj = {
      openid: _options.openid,
      pageid: _options.pageid,
      psn: _options.psn,
    }
    if (_options.refereeopenid) {
      postObj.refereeopenid = _options.refereeopenid;
    }
    if (_options.rscuid) {
      postObj.rscuid = _options.rscuid;
    }
    httprsh5.post(apirsh5.action.actShare, postObj);
  }
}

function actEntry(strPhone) {
  if (_options.saleslead.leavePhone) {
    let postObj = {
      phone: strPhone,
      pageid: _options.pageid,
      channelid: _options.channelid,
      openid: _options.openid
    }
    if (_options.refereeopenid) {
      postObj.refereeopenid = _options.refereeopenid;
    }
    if (_options.rscuid) {
      postObj.rscuid = _options.rscuid;
    }
    httprsh5.post(apirsh5.action.actEntry, postObj);
  }
}

/**
 * userevent 抽奖的时候传 wheel_draw ，留电的时候传 wheel_phone
 * usereventValue
 * usereventDesc
 * phone
 * @param {*} params 
 */
function actUserEvent(params) {
  let postObj = {
    openid: _options.openid,
    pageid: _options.pageid,
    ...params
  }
  if (_options.refereeopenid) {
    postObj.refereeopenid = _options.refereeopenid;
  }
  if (_options.rscuid) {
    postObj.rscuid = _options.rscuid;
  }
  httprsh5.post(apirsh5.action.actUserEvent, postObj);
}

function getRsShareUrl(url) {
  let query = util.getParamFromUrl(url);
  if (!query.rscuid) {
    if (_options.rscuid) {
      query.rscuid = _options.rscuid
    }
    if (_options.isSale) {
      query.rscuid = _options.openid
    }
    if (query.rscuid) {
      url = util.addUrlParamFromObj(url, {
        rscuid: query.rscuid
      })
    }
  }
  return url;
}

export default {
  options: _options,
  init,
  actShare,
  actEntry,
  actUserEvent,
  getRsShareUrl
}